/**
 * 用户相关
 */
import axios from '../axios';
const baseURL='/common';
// 获取平台配置地址
export function getProductUrl(urlType,callBack) {
    return axios({
        method: 'get',
        url: `/getProductUrl?urlType=${urlType}`,
        baseURL: baseURL,
    }).then((res) => {
        if (res.data.success && res.data.data) {
            let url = res.data.data.url;
            if (url) {
                callBack(url.indexOf('http') < 0 ? 'http://' + url : url);
            } else {
                console.log("地址不存存在")
                callBack('');
            }
        } else {
            console.log("地址不存存在")
            callBack('');
        }
    }).catch(() => {
        console.log("获取地址异常")
        callBack('');
    });
}
export function getUrl(params) {
    return axios({
        method: 'get',
        url: '/fastdfs/url',
        params: params
    });
}
// 项目管理列表
export function deletePageList(params = {}) {
    return axios({
        method: 'post',
        url: '/projectManage/deletePageList',
        data: params
    })
}
//用户管理 重置密码
export function passwordReset(params = {}) {
  return axios({
    method: 'get',
    url: `/user/resetUserPassword?userId=${params.userId}`,

  });
}
//用户管理 冻结恢复
export function setUserUseData(params = {}) {
  return axios({
    method: 'get',
    url: `/user/setUserUse`,
    params

  });
}
// 获取首页表格数据
export function getDistrictData(param) {
  // this.loading = true;
  return axios({
    method: 'post',
    // baseURL: baseURL,
    url: `/project/attendance/gaoCheng/district`,
    data: { ...param }
  })
}
// 项目登记根据名称查询
export function queryProjectByName(params = {}) {
    return axios({
        method: 'get',
        url: '/project/management/queryProjectByName',
        params: params
    });
}
// 秘钥详情
export function getProjectTokenDetail(params = {}) {
    return axios({
        method: 'get',
        url: '/project/getProjectTokenDetail',
        params: params
    })
}
// 秘钥编辑
export function projectTokenEditSave(params = {}) {
    return axios({
        method: 'post',
        url: '/project/projectTokenEditSave',
        data: params
    })
}
// 企业编辑回显
export function corpEditDetail(params = {}) {
    return axios({
        method: 'get',
        url: '/corp/editDetail',
        params: params
    })
}
// 企业编辑 - 提交
export function corpEditSave(params = {}) {
    return axios({
        method: 'post',
        url: '/corp/editSave',
        data: params
    })
}
// 项目 编辑 详情
export function getProjectDetail(params = {}) {
    return axios({
        method: 'get',
        url: '/project/getProjectDetail',
        params: params
    });
}
// // 项目 编辑 提交
export function projectEditSave(params = {}) {
    return axios({
        method: 'post',
        url: '/project/projectEditSave',
        data: params
    });
}
// 参建单位列表
export function projectCorps(params = {}) {
    return axios({
        method: 'get',
        url: '/project/projectCorps',
        params: params
    });
}
// 岗位预警 - 人员详情 - 关键岗位人员信息
export function projectKeyPositionWorker(params = {}) {
    return axios({
        method: 'get',
        url: '/worker/sx/projectKeyPositionWorker',
        params: params
    });
}
//岗位预警--人员详情导出
export function projectKeyPositionWorkerExport(params = {}) {
    return axios({
        method: 'get',
        responseType: 'arraybuffer',
        url: '/worker/sx/projectKeyPositionWorker/export',
        params: params
    });
}
// 获取全国行政区
export function getNationwide(params = {}) {
    return axios({
        method: 'get',
        url: '/dict/nationwide',
        params: params
    });
}
//出勤率导出
export function attendanceExport(params = {}) {
    return axios({
        method: 'get',
        responseType: 'arraybuffer',
        url: '/project/workers/export',
        params: params
    });
}